import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>職業安全衛生</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><p>職業安全一直是我們高度重視的議題，和平電力致力關注員工健康、工作環境和工作安全，其中“安全”更是員工、承包商和管理層的共同責任，「零工傷」是我們的重要目標，和平電力已通過 ISO 45001 職業安全衛生管理系統認證。</p><div class=\"gallery\"><div class=\"item imgContainer1-1\"></div><div class=\"item imgContainer1-2\"></div><div class=\"item imgContainer1-3\"></div></div></div></section>", 2)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "職工的安全健康", -1)
const _hoisted_6 = { class: "employeeSafety" }
const _hoisted_7 = { class: "tit" }
const _hoisted_8 = { class: "desp" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "承攬商的安全衛生教育", -1)
const _hoisted_11 = { class: "supplyierSafety" }
const _hoisted_12 = { class: "tit" }
const _hoisted_13 = { class: "desp" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "多元健康促進", -1)
const _hoisted_17 = { class: "multiHealth" }
const _hoisted_18 = { class: "tit" }
const _hoisted_19 = { class: "desp" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<section class=\"sect3\"><div class=\"ctx\"><div class=\"sectTit\">特殊資格人員的精進訓練</div><p>每年依照政府現行法規，辦理勞動、職安及災害預防訓練等相關課程，並依法安排同仁進行急救人員、缺氧作業、危險性設備、職業安全衛生業務主管等相關證照之新訓與回訓。另外，透過盤點工作環境中的潛在安全危害因子，進行安全宣導及消防演習，並參加政府舉辦之各類型災害防治觀摩及各類職安證照回訓課程。</p><div class=\"gallery\"><div class=\"left\"><div class=\"imgContainer4-1\"></div></div><div class=\"right\"><div class=\"imgContainer4-2\"></div><div class=\"imgContainer4-3\"></div><div class=\"imgContainer4-4\"></div></div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_center = _resolveComponent("center")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeSafety, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", {
                  class: "thumbnail",
                  style: _normalizeStyle(_ctx.setThumbnail(row.thumbnail))
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(row.tit), 1)
                ], 4),
                _createElementVNode("div", _hoisted_8, _toDisplayString(row.desp), 1)
              ]))
            }), 128))
          ]),
          _hoisted_9,
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplyierSafety, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(row.tit), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(row.desp), 1),
                _createElementVNode("img", {
                  class: "pic",
                  src: _ctx.setSupplyierPic(row.thumbnail)
                }, null, 8, _hoisted_14)
              ]))
            }), 128))
          ]),
          _hoisted_15,
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiHealth, (row, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(row.tit), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(row.desp), 1)
              ]))
            }), 128)),
            _createVNode(_component_swiper, {
              modules: _ctx.modules,
              "slides-per-view": 1,
              "space-between": 1,
              autoplay: {delay:3000, disableOnInteraction:false},
              speed: 1000,
              loop: true,
              pagination: {clickable:true},
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange,
              class: "swiper"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, { class: "cover cover1" }),
                _createVNode(_component_swiper_slide, { class: "cover cover2" }),
                _createVNode(_component_swiper_slide, { class: "cover cover3" }),
                _createVNode(_component_swiper_slide, { class: "cover cover4" }),
                _createVNode(_component_swiper_slide, { class: "cover cover5" }),
                _createVNode(_component_swiper_slide, { class: "cover cover6" })
              ]),
              _: 1
            }, 8, ["modules", "onSwiper", "onSlideChange"])
          ])
        ])
      ]),
      _hoisted_20
    ]),
    _createVNode(_component_Footer)
  ], 64))
}